import Helpers from "../Controls/helpers";
import "../../style/scss/App.scss";

export default function ConnectionListItem({ connection, onEdit }) {
  const id = connection?.ID ?? connection?.id;
  const statusLabel = Helpers.connectionStatusLabel(connection?.Status ?? connection?.status);

  return (
    <button
      type="button"
      className="centered skillLink connection-list-item"
      data-testid={`connection-edit-${id}`}
      onClick={() => onEdit?.(id)}
    >
      <div className="Connection mobilePanel">
        <span className="title">
          {connection.FirstName}&nbsp;{connection.LastName}
        </span>
        <span className="byline">{connection.Title || connection.Email}</span>
        {statusLabel ? <span className="byline">Status: {statusLabel}</span> : null}
      </div>
    </button>
  );
}
